module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addAddress":"Add Address","addresses":"Addresses"},"fr":{"addAddress":"Ajouter une adresse","addresses":"Adresses"}}')
  delete Component.options._Ctor
}
